import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CTAButton from '../../shared/CTAButton';
import Loading from '../../shared/Loading';
import payOnline from '../../../lib/images/navy-online-payments.svg';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { loading } from '../../../actions/sessions';

export default function ApplyNowIntro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const merchant = useSessionEntity('merchant');
  const session = useSelector(state => state.sessions.get('session'));

  useEffect(() => {
    dispatch(loading(false));
  }, []);

  if (!merchant) return <Loading className="w-14 h-14" />;

  return (
    <div role="main" id="content" className="mx-auto text-center mb-6">
      <div className="text-2xl font-avenir-black mobile:py-0 mobile:px-6">
        <p className="text-navy-blue leading-10">
          Buy what you need, pay over time
        </p>
        <img
          src={payOnline}
          alt="pay-online-vector"
          className="w-[55%] mx-auto my-6"
        />
      </div>
      <div className="mx-auto max-w-md md:max-w-lg">
        <div className="text-navy-blue">
          <h2 className="text-base md:text-lg font-avenir-black">
            Fast, Easy Financing with No Money Down
          </h2>
          <p className="font-avenir-book text-base text-dark-gray mb-2">
            Instant decisions. Checking your rate will{' '}
            <strong className="text-black">not</strong> affect your credit
            score.
          </p>
        </div>
        <div className="flex justify-between items-center my-5">
          <div className="mx-1.5 xxs:m-0 py-4 px-[0.85rem] sm:p-4 sm:m-2 flex flex-col rounded-lg border border-black border-opacity-5 min-w-min xxs:min-w-[7.5rem]">
            <div className="icon-group-1 flex justify-center items-center py-4 px-2 rounded-[0.625rem]">
              <FontAwesomeIcon
                icon={['far', 'money-bill-trend-up']}
                className="text-white text-2xl"
              />
            </div>
            <div className="font-avenir-book">
              <div className="text-sm my-2 mx-auto leading-5">
                Up to
                <p className="text-navy-blue text-lg font-avenir-black mx-2">
                  {session?.hasCustomFlag('vip') ? '$200k' : '$50k'}
                </p>
                financing
              </div>
            </div>
          </div>
          <div className="mx-1.5 xxs:m-0 py-4 px-[0.85rem] sm:p-4 sm:m-2 flex flex-col rounded-lg border border-black border-opacity-5 min-w-min xxs:min-w-[7.5rem]">
            <div className="icon-group-2 flex justify-center items-center py-4 px-2 rounded-[0.625rem]">
              <FontAwesomeIcon
                icon={['far', 'badge-percent']}
                className="text-white text-2xl"
              />
            </div>
            <div className="font-avenir-book">
              <div className="text-sm my-2 mx-auto leading-5">
                Pay
                <p className="text-navy-blue text-lg font-avenir-black mx-2">
                  0%
                </p>
                for
                <span className="mx-1">
                  {merchant.get('active_promo')
                    ? merchant.get('active_promo').get('max_net_duration')
                    : 30}
                </span>
                days
              </div>
            </div>
          </div>
          <div className="mx-1.5 xxs:m-0 py-4 px-[0.85rem] sm:p-4 sm:m-2 flex flex-col rounded-lg border border-black border-opacity-5 min-w-min xxs:min-w-[7.5rem]">
            <div className="icon-group-3 flex justify-center items-center py-4 px-2 rounded-[0.625rem]">
              <FontAwesomeIcon
                icon={['far', 'calendar-check']}
                className="text-white text-2xl"
              />
            </div>
            <div className="font-avenir-book">
              <div className="text-sm my-2 mx-auto leading-5">
                Up to
                <p className="text-navy-blue text-lg font-avenir-black mx-2">
                  12
                </p>
                month terms
              </div>
            </div>
          </div>
        </div>
      </div>
      <CTAButton
        ariaLabel="apply-now-button"
        containerClass="justify-center"
        buttonClass="w-3/4 mobile:w-2/3 mx-auto md:w-full bg-primary-blue font-avenir-black tracking-wider text-white rounded-full uppercase py-3 px-6 mx-8 text-sm md:text-base inline-block hover:bg-navy-blue flex justify-center items-center"
        buttonText={`Let's Go`}
        onClick={() => history.push(location.state ? location.state.redirect_url : location.pathname)}
      />
      <p className="mt-4 font-avenir-medium mb-6">
        Already have a Credit Key account?
        <span
          className="cursor-pointer mx-1 text-primary-blue"
          onClick={() => history.push('/init/existing_user')}
        >
          Sign In
        </span>
      </p>
    </div>
  );
}
